import axios from "axios";
import { config } from "../../config";

import {
  AvailabilityRequest,
  AvailabilityResponse,
  VIEWED_HOTEL_AVAILABILITY_LOADING,
} from "redmond";
import { hotelAvailabilityApiPrefix } from "../paths";
import { trackEvent } from "../analytics/trackEvent";
import dayjs from "dayjs";

export const fetchHotelAvailability = (
  body: AvailabilityRequest
): Promise<AvailabilityResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const startTime = dayjs();
      const res = await axios.post(hotelAvailabilityApiPrefix, body, {
        baseURL: config.baseURL,
      });

      trackEvent({
        eventName: VIEWED_HOTEL_AVAILABILITY_LOADING,
        properties: {
          runtime: dayjs().diff(startTime, "seconds", true),
        },
      });
      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });
